module.exports = __webpack_public_path__ + "img/bg_6.40855156.png";